import {Container} from 'react-bootstrap'

export default function BrandStatement() {
  return (
    <Container id="about" className='about'>
      <hr />
      <h1>About Me</h1>
      <p>
        As a former teacher, I have a real passion for helping, working with and inspiring others with my personable and relaxed demeanour. Thriving in environments founded on mutual trust, I excel in team dynamics, readily assuming leadership roles when needed.

        Deciding to change career, I enrolled in the General Assembly software engineer immersive bootcamp to learn and develop new skills that will aid in guiding this career change.

        Transitioning into software engineering, I'm eager to apply my teaching-honed skills. My time at GA marked a new exciting career direction. I am currently seeking opportunities to enhance my skills; I aspire to move into a full-stack role, leveraging strengths cultivated throughout my entire professional journey. 

        I am available for positions now, having completed my course at General Assembly in March 2024. 
      </p>
    </Container>
  )
}
